import { applyMiddleware, compose, createStore } from 'redux'
import thunk from 'redux-thunk'
import { createEpicMiddleware } from 'redux-observable'
import { createMiddleware } from 'redux-beacon'
import GoogleTagManager from '@redux-beacon/google-tag-manager'
// import logger from '@redux-beacon/logger'
import Immutable from 'seamless-immutable'
// import reduxLogger from 'redux-logger'

import makeRootReducer from './reducers'
import RootEpic from '../Epics'
import FetchingMiddleware from '../Core/Services/FetchingMiddleware'
import ErrorMiddleware from '../Core/Services/ErrorMiddleware'
import GTMMiddleware from '../Core/Services/GTMMiddleware'
import CallBackMiddleware from '../Core/Services/CallBackMiddleware'
import StackdriverMiddleware from '../Core/Services/StackdriverMiddleware'
import { cookie } from 'devx-js-utilities'

import { INITIAL_STATE as InputHelpsInitial } from '../Core/Redux/InputHelpsRedux'
import { INITIAL_STATE as GeneralInitial } from '../Core/Redux/GeneralRedux'

import passwords from '../Core/passwords.json'

const gtm = GoogleTagManager()

import q from '../pass2'
import { config } from '../Config/ConfigLoader'

import logger from 'redux-logger'

const __DEV__ = true

let testing = false
if (cookie.readCookie('suriTesting') && cookie.readCookie('suriTesting') === passwords.testing) {
  testing = true
}

export default (initialState = {}, turnOffHydrate = false) => {
  const epicMiddleware = createEpicMiddleware()

  // ======================================================
  // Middleware Configuration
  // ======================================================
  const middleware = [thunk]
  const a = q + 'a'

  // ======================================================
  // Store Enhancers
  // ======================================================
  const enhancers = []
  if (__DEV__) {
    const devToolsExtension = window.__REDUX_DEVTOOLS_EXTENSION__
    if (typeof devToolsExtension === 'function') {
      enhancers.push(devToolsExtension())
    }
  }

  middleware.push(epicMiddleware)
  middleware.push(FetchingMiddleware)
  middleware.push(ErrorMiddleware)
  middleware.push(CallBackMiddleware)
  middleware.push(createMiddleware(GTMMiddleware, gtm, testing ? { logger } : {}))
  middleware.push(StackdriverMiddleware)

  // middleware.push(reduxLogger)

  // ======================================================
  // Store Instantiation and HMR Setup
  // ======================================================
  const store = createStore(
    makeRootReducer(),
    new Immutable(turnOffHydrate ? initialState : {}),
    compose(applyMiddleware(...middleware), ...enhancers),
  )

  window.snapSaveState = () => {
    const state = store.getState()
    return {
      __PRELOADED_STATE__: {
        userData: undefined,
        appData: {
          product: {
            ...state.appData.product,
            resources: {},
            transManufacturer: {},
            transModel: {},
            productContent: config.getDefaultContent(),
            specification: config.getDefaultSpecification(),
          },
          inputHelps: {
            ...InputHelpsInitial,
            productInputHelps: state.appData.inputHelps.productInputHelps,
          },
          general: { ...GeneralInitial },
        },
      },
    }
  }
  store.asyncReducers = {}

  if (module.hot) {
    module.hot.accept('./reducers', () => {
      const reducers = require('./reducers').default
      store.replaceReducer(reducers(store.asyncReducers))
    })
  }

  epicMiddleware.run(RootEpic)

  return store
}
